import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appRenderTarget]',
  standalone: false,
})
export class RenderTargetDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
